import { Button } from '@shared/components/shadcn';
import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type { ComponentProps } from 'react';
import type { LotteryName } from '../../../../lottery-purchases/types';
import { YourNumbersCard } from '../YourNumbersCard/YourNumbersCard';

type YourNumbersEmptyStateProps = ComponentProps<'div'> & {
  betUrl: string;
  lotteryName: LotteryName;
  'data-testid'?: string;
};

function YourNumbersEmptyState({ betUrl, lotteryName, className, 'data-testid': dataTestId = 'your-numbers-empty-state', ...props }: YourNumbersEmptyStateProps) {
  const t = useTranslations('lotteries.results.your_numbers.empty_state');
  const tLottery = useTranslations(`lotteries.${lotteryName}`);

  return (
    <YourNumbersCard className={twMerge('p-4', className)} data-testid={dataTestId} {...props}>
      <div className="flex w-full flex-col items-center gap-4 self-center">
        <p className="paragraph text-foreground w-full whitespace-pre-line text-center" data-testid={`${dataTestId}-message`}>
          {t('message', { lotteryDisplayName: tLottery('name') })}
        </p>
        <Button asChild size="m" variant="primary" className="w-full" data-testid={`${dataTestId}-cta`}>
          <Link href={betUrl}>{t('cta')}</Link>
        </Button>
      </div>
    </YourNumbersCard>
  );
}

export { YourNumbersEmptyState, type YourNumbersEmptyStateProps };
